module.exports = __webpack_public_path__ + "./assets/img_hushan_color__958027fd59456647fa16d015d744ea49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hushan_color.jpg
// module id = 637
// module chunks = 12